import { createSlice } from '@reduxjs/toolkit';
import {
  getStorageItem,
  setStorageItem,
  removeStorageItem,
} from '../../utils/storage';

const SCENARIO_LABEL = 'compodium-preflight-scenario';
const DEFAULT_SCENARIO_VALUE = 'default';
const DEFAULT_ONCOMPLETION = () => {
  if (window.history.length > 1) {
    window.history.back();
  } else {
    window.close();
  }
};

export const scenarioSlice = createSlice({
  name: 'scenario',
  initialState: {
    scenario: getStorageItem(
      localStorage,
      SCENARIO_LABEL,
      DEFAULT_SCENARIO_VALUE,
      false
    ),
    onCompletion: DEFAULT_ONCOMPLETION,
    parentOrigin: null,
  },
  reducers: {
    setScenario: (state, action) => {
      state.scenario = action.payload;
      setStorageItem(localStorage, SCENARIO_LABEL, action.payload, false);
    },
    clearScenario: () => {
      removeStorageItem(localStorage, SCENARIO_LABEL);
    },
    setOnCompletion: (state, action) => {
      state.onCompletion = action.payload;
    },
    setParentOrigin: (state, action) => {
      state.parentOrigin = action.payload;
    },
  },
});

export const { setScenario, clearScenario, setOnCompletion, setParentOrigin } =
  scenarioSlice.actions;

export default scenarioSlice.reducer;
